import commonText from './commonText';

const standardModes = {
  tv: {
    displayLabel: 'Broadcast TV',
    initialSelected: false,
    initialImpactFactor: 1.5,
    initialDiscount: 0.75,
    costText: '(CPP)',
    costTooltip: '(CPP)',
    frequencyText: commonText.frequencyText,
    frequencyTooltip: commonText.frequencyTooltip,
    percentText: commonText.percentText,
    percentTooltip: commonText.percentTooltip,
    impactFactorText: commonText.impactFactorText,
    impactFactorTooltip: commonText.impactFactorTooltip,
    discountTooltip: commonText.discountTooltip,
    icon: 'tv',
  },
  spanish_tv: {
    displayLabel: 'Spanish TV',
    initialSelected: false,
    initialImpactFactor: 1.5,
    initialDiscount: 0.75,
    costText: '(CPP)',
    costTooltip: '(CPP)',
    frequencyText: commonText.frequencyText,
    frequencyTooltip: commonText.frequencyTooltip,
    percentText: commonText.percentText,
    percentTooltip: commonText.percentTooltip,
    impactFactorText: commonText.impactFactorText,
    impactFactorTooltip: commonText.impactFactorTooltip,
    discountTooltip: commonText.discountTooltip,
    icon: 'tv',
  },
  cable: {
    displayLabel: 'Cable TV',
    initialSelected: false,
    initialImpactFactor: 1.5,
    initialDiscount: 0.75,
    costText: '(CPP)',
    costTooltip: '(CPP)',
    frequencyText: commonText.frequencyText,
    frequencyTooltip: commonText.frequencyTooltip,
    percentText: commonText.percentText,
    percentTooltip: commonText.percentTooltip,
    impactFactorText: commonText.impactFactorText,
    impactFactorTooltip: commonText.impactFactorTooltip,
    discountTooltip: commonText.discountTooltip,
    icon: 'tv',
  },
  mail: {
    displayLabel: 'Direct Mail',
    initialSelected: false,
    initialImpactFactor: 1.25,
    initialDiscount: 0.5,
    costText: '(Cost Per Piece)',
    costTooltip: '(Cost Per Piece)',
    frequencyText: commonText.frequencyText,
    frequencyTooltip: commonText.frequencyTooltip,
    percentText: commonText.percentText,
    percentTooltip: commonText.percentTooltip,
    impactFactorText: commonText.impactFactorText,
    impactFactorTooltip: commonText.impactFactorTooltip,
    discountTooltip: commonText.discountTooltip,
    initialFlightSize: 1,
    flightText: commonText.flightText,
    flightTooltip: commonText.flightTooltip,
    icon: 'envelope-open-o',
  },
  phone: {
    displayLabel: 'Phone',
    initialSelected: false,
    initialImpactFactor: 1,
    initialDiscount: 0.5,
    costText: '(Cost Per Dial)',
    costTooltip: '(Cost Per Dial)',
    frequencyText: commonText.frequencyText,
    frequencyTooltip: commonText.frequencyTooltip,
    percentText: commonText.percentText,
    percentTooltip: commonText.percentTooltip,
    impactFactorText: commonText.impactFactorText,
    impactFactorTooltip: commonText.impactFactorTooltip,
    discountTooltip: commonText.discountTooltip,
    icon: 'phone',
  },
  radio: {
    displayLabel: 'Radio',
    initialSelected: false,
    initialImpactFactor: 0.75,
    initialDiscount: 0.75,
    costText: '(CPP)',
    costTooltip: '(CPP)',
    frequencyText: commonText.frequencyText,
    frequencyTooltip: commonText.frequencyTooltip,
    percentText: commonText.percentText,
    percentTooltip: commonText.percentTooltip,
    impactFactorText: commonText.impactFactorText,
    impactFactorTooltip: commonText.impactFactorTooltip,
    discountTooltip: commonText.discountTooltip,
    icon: 'signal',
  },
};

export default standardModes;
